import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveUserFailed, saveUserSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* saveUser(action) {
  try {
    const { id, data } = action.payload;
    if (data && !data.password) {
      delete data.password;
    }
    const url = `${BACKEND_URL}/api/v1/user/${id}`;
    const dataResponse = yield makeRequest(url, data, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(saveUserSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(saveUserFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(saveUserFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
